import { jsx as _jsx, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../../redux/hooks.js';
import { errorStatusSelector } from '../../resetPasswordSlice.js';
export const ResetPasswordAlert = () => {
    const errorStatus = useAppSelector(errorStatusSelector);
    const { t } = useTranslation();
    const getLabel = () => {
        switch (errorStatus) {
            case 500:
                return t('loginregistration.resetPassword.error.serverError');
            case 400:
                return t('loginregistration.resetPassword.error.serverError');
            default:
                return null;
        }
    };
    const label = getLabel();
    return (_jsx(_Fragment, { children: errorStatus && label ? (_jsx(Alert, { variant: 'negative', role: 'alert', children: label })) : null }));
};
//# sourceMappingURL=ResetPasswordAlert.js.map